import PostApi from '@/postApi';
export default {
	namespaced: true,
	state: {
	},
	actions: {
		async getQrCode({commit},param) {
			let getQrCode = await PostApi.postGetQrCode(param);
			console.log(commit);
			return getQrCode;
		},
	},
	mutations: {
	},
}
